import { render, staticRenderFns } from "./AppVersionConfirmationHistory.vue?vue&type=template&id=553952d9"
import script from "./AppVersionConfirmationHistory.vue?vue&type=script&lang=ts"
export * from "./AppVersionConfirmationHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports